import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {useCallback, useEffect} from "react";
import {Button, Title3} from "@fluentui/react-components";
import {UserPolicyIO} from "../../../io/UserIO";
import {UserPolicyValueObject} from "../../../data/value-object/user/UserPolicyValueObject";
import {useUserPolicyPutState} from "../../../data/data-transfer-object-state/user/UserPolicyPutState";
import {UserPolicyPutFields} from "../../data-transfer-object-field/user/UserPolicyPutField";

enum Phase {
    Loading,
    Waiting,
    Putting,
    Finished,
}

export default function Edit(props: RouterProps) {
    const params = useParams<{ userPolicyId: string }>()
    const item = useStatePair<UserPolicyValueObject | undefined>(undefined)
    const phase = useStatePair<Phase>(Phase.Loading)
    const state = useUserPolicyPutState()

    useEffect(() => {
        if (params.userPolicyId !== undefined) {
            UserPolicyIO
                .getById(BigInt(params.userPolicyId))
                .then(value => {
                    item.setter(value)
                    state.fromValueObject(value)
                    phase.setter(Phase.Waiting)
                })
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    const onDoneClick = useCallback(() => {
        const id = item.value?.id
        if (id === undefined) {
            return
        }

        phase.setter(Phase.Putting)
        UserPolicyIO
            .put(id, state.toDataTransferObject())
            .then(() => {
                phase.setter(Phase.Finished)
                alert('수정되었습니다.')
                document.location = `/users/policies/${id}`
            })
            .catch(reason => {
                console.error(reason)
                alert('수정을 실패했습니다.')
                phase.setter(Phase.Waiting)
            })
    }, state.values())

    return <>
        <div className={props.styles.column16}>
            <Title3>수정</Title3>
            <UserPolicyPutFields
                {...props}
                state={state} />
            <div className={props.styles.row}>
                <Button
                    appearance={'primary'}
                    disabled={phase.value !== Phase.Waiting}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </div>
        </div>
    </>
}